import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Header } from 'pages/Header';
import { Footer } from 'pages/Footer';
import { BASE_PATH, SUB_DIRECTORY } from 'constants/general';
import "./style.sass";
import { useServices } from 'hooks/useServices';
import { useIsMobile } from 'hooks/useIsMobile';
import SlidersEmarsys from 'components/Emarsys/SlidersEmarsys/index_product';
import HeaderMobileCredito from 'components/Header/HeaderMobileCredito';
import { useHomePage } from 'hooks/useHomePage';
import OTPInput from "otp-input-react";
import { useForm } from 'react-hook-form';
import { ProgressBar } from 'components/ProgressBar';
import { decodeStorage } from 'functions/storageBase64';
import { postNipIncode } from 'services/NipIncode';
import { SolicitudFinalizadaMobile } from 'pages/Credito/10-SolicitarTarjeta/solicitudFinalizadaMobile';
import { Error500 } from 'components/Error/Error500';
import { SolicitudCreditoAprobado } from 'pages/NuevoCredito/CreditoAprobado/SolicitudCreditoAprobado';
import { postRequestShort } from 'services/RequestShortIncode';
import {ModalLoadingCredit} from 'components/Loading';
import { PantallaError } from 'pages/NuevoCredito/MensajesErrores/pantallaError';



export function ComprobarNip() {

    const history = useHistory();
    const { isMobile } = useIsMobile();

    const [ loading, setLoading ] = useState(false);

    const profileData = decodeStorage('profileData');

    const [tipoDeRespuestaCredito, setTipoDeRespuestaCredito] = useState(0);

    const [numFolio, setNumFolio] = useState("");

    const [idCredito, setIdCredito] = useState("");

    const [errorCode, setErrorCode] = useState();

    const [codigoOTP, setCodigoOTP] = useState("");

    const [codigoInvalido, setCodigoInvalido] = useState(false);

    const[validateOTP, setValidateOTP] = useState(false);

    const[mensajeErrorOTP, setMensajeErrorOTP] = useState(null);

    const[verDigitos, setVerDigitos] = useState(false);

    const nipStorage = decodeStorage("infoNipStorage");
    
    const[nipAnterior, setNipAnterior] = useState(Number(nipStorage.Nip));

    const [postEnviarNipRes, setPostEnviarNipRes] = useState(false);

    const [postRequestShortRes, setPostRequestShortRes] = useState(false);

    const infoPersonalRecabadaStorage = decodeStorage("infoPersonalRecabadaStorage")
    const infoDireccionStorage = decodeStorage("infoDireccionStorage");
    const infoOcupacionStorage = decodeStorage("infoOcupacionStorage");
    const infoIngmensualStorage = decodeStorage("infoIngmensualStorage");
    const infoPreguntasSinTelmexStorage = decodeStorage("infoPreguntasSinTelmexStorage");

    const infoLineaTelmexStorage = decodeStorage('infoLineaTelmexStorage');
    const [lineaTelmex, setLineaTelmex] = useState(infoLineaTelmexStorage?.LineaTelmex);

    const [postNipRes, setPostNipRes] = useState(false);

    const[erorrPrueba, setErorrPrueba] = useState();
    const[seEnvia, setSeEnvia] = useState();

    const [objRespuestaError, setObjRespuestaError] = useState(false);


    //- Codigo de instana para track de pagina 
    useEffect(() => {
        window.ineum('page', 'Before Start  Credit-Page');
        window.ineum('meta', 'portal', 'Credito CS');
        window.scrollTo(0, 0);
    }, [])

    const cancelar = () => {
        //history.replace(`${BASE_PATH}`);
        history.goBack(-1);
    }


    const { register, handleSubmit, errors } = useForm({
        defaultValues: {
            codigoOTP: 0
        }
    });


    const valOTP = {
        required: 'Campo obligatorio',
    };

    


    useEffect(() => {
        console.log("nipStorage", nipStorage);
        console.log("infoDireccionStorage",infoDireccionStorage);
    }, [])

    // activa boton de validar codigoOTP
    useEffect(() => {
        console.log("activa boton de validar codigoOTP")
        if(validateOTP === true){
            if(codigoOTP?.length === 0){
                setCodigoInvalido(true);
                setMensajeErrorOTP({error: "Campos vacios"});
            } 
            else if(Number(codigoOTP) !== nipAnterior){
                setCodigoInvalido(true);
                setMensajeErrorOTP({error: "Tu NIP no coincide"});
            }
            else{
                setCodigoInvalido(false);
                setMensajeErrorOTP(null);
            }
        }
    }, [codigoOTP,validateOTP])



    const sendFormInformacionNip = () =>{
       //valida nip antes
        if(!codigoInvalido){
            console.log("si pasa");
            setLoading(true); 
            postNipIncode({         
                "externalId": `${profileData?.idClaro}`,
                "nip": codigoOTP,
                "tipo": "VALIDAR" //registro, Validar
            })
            .then(setPostNipRes)
        }
    }

    const verificarValidacionesOTP = () =>{
        setValidateOTP(true);
    }

    //postNipIncode res
    useEffect(() => {
        if (postNipRes) {
            console.log("respuesta nip",postNipRes)
            if(postNipRes?.data?.codMen === '200'){ 
                setLoading(true); 
                let data_request = {};
                //console.log({"infoDireccionStorage": infoDireccionStorage,"infoOcupacionStorage": infoOcupacionStorage,"infoIngmensualStorage":infoIngmensualStorage,"infoPreguntasSinTelmexStorage":infoPreguntasSinTelmexStorage});
                //Request-short
                //seteavariables
                let variables = {
                    "STarjeta": "SI",
                    "SHipotecario": "SI",
                    "SAutomotriz": "SI"
                }; 
                //si cuanta con linea telmex
                if(!lineaTelmex){
                    data_request = {...infoPersonalRecabadaStorage,...infoDireccionStorage, ...infoOcupacionStorage, ...infoIngmensualStorage, ...variables};
                }else{
                    data_request = {...infoPersonalRecabadaStorage,...infoDireccionStorage, ...infoOcupacionStorage, ...infoIngmensualStorage, ...infoPreguntasSinTelmexStorage};
                }
                console.log("objeto unido data_request:",data_request);
                setSeEnvia(JSON.stringify(data_request));
                postRequestShort(data_request)
                .then(setPostRequestShortRes)
            }else{
                setLoading(false); 
                //mandar error modalito
                console.log("ocurrio error")
                //history.push(`${BASE_PATH}${SUB_DIRECTORY}home`);
            }

        }
    }, [postNipRes])

    //RequestShortRes res
    useEffect(() => {
        if (postRequestShortRes) {
            console.log("respuesta claro score",postRequestShortRes)
            if(postRequestShortRes?.statusCode === 200){
                setLoading(false); 
                //Solicitud pendiende de aprobar
                if(postRequestShortRes?.data?.tipo === "0"){
                    setNumFolio({folio: postRequestShortRes?.data?.folio});
                    setTipoDeRespuestaCredito(1);
                }
                //Crédito aprobado en automático
                //else if(postRequestShortRes?.data?.tipo === 2){
                //    setTipoDeRespuestaCredito(2);
                    //setIdCredito(postRequestShortRes?.data?.idCredito)
                //}
                //Solicitud Rechazada Registro duplicado
                else if(postRequestShortRes?.data?.tipo === "1"){
                    history.push(`${BASE_PATH}${SUB_DIRECTORY}error-credito/solicitud-rechazada-tipo1`);
                    //setObjRespuestaError(postRequestShortRes?.data);    
                    //setTipoDeRespuestaCredito(3);
                }
                //No coincide documento y Selfie, Pertenece a lista negra
                else if(postRequestShortRes?.data?.tipo === "2"){
                    history.push(`${BASE_PATH}${SUB_DIRECTORY}error-credito/solicitud-rechazada-tipo2`);
                    //setObjRespuestaError(postRequestShortRes?.data);    
                    //setTipoDeRespuestaCredito(3);
                }    
            }else{
                //mandar error modalito
                setLoading(false); 
                console.log("ocurrio error")
                setErorrPrueba(postRequestShortRes?.data);
            }

        }
    }, [postRequestShortRes])

    

    const handlerVerDigitos = () =>{
        setVerDigitos(!verDigitos);
    }


    return (
        errorCode >= 500
            ? 
                <div className="modalCredito full">
                    <div className="contentModal">
                        <HeaderMobileCredito title="Solicitud de Crédito Claroshop" type="back" />
                        <Error500 />
                    </div>
                </div>
            :
                <>
                    { loading && <ModalLoadingCredit /> }
                    {tipoDeRespuestaCredito === 0 && 
            
                        <div className="homeMobile">
                            <HeaderMobileCredito title={"Solicitud de crédito ClaroShop"} type="backFull" />  
                            <main className='nuevoCredito ultimosPasos'>
                                <ProgressBar progress={100} />
                                <form onSubmit={handleSubmit(sendFormInformacionNip)}>
                                    <section className="sectionPrincipalBeneficios fullBottom">
                                    
                                        <p className='tLeft bold'>Ingresa tu nip nuevamente</p>

                                        <OTPInput
                                            value={codigoOTP}
                                            onChange={setCodigoOTP}
                                            autoFocus
                                            OTPLength={4}
                                            otpType="number"
                                            disabled={false}
                                            className="contenedorOTP"
                                            secure={verDigitos ? false : true}
                                            inputClassName={codigoInvalido ? "inputOTP errorActivo" : "inputOTP"}
                                        />

                                        {mensajeErrorOTP && mensajeErrorOTP?.error 
                                            ? <div className="error check-nip"> {mensajeErrorOTP?.error} </div>
                                            : null
                                        }

                                        {!verDigitos ?
                                            <p className='center bold showDigits openEye' onClick={handlerVerDigitos}>
                                                Ver digitos
                                            </p>
                                            :
                                            <p className='center bold showDigits closedEye' onClick={handlerVerDigitos}>
                                                Ocultar digitos
                                            </p>
                                        }
                                            

                                    </section>
                                    <div className="boxBtnSolicitar marginBottom30">
                                        <button className="btnSolicitar" onClick={verificarValidacionesOTP}>Comenzar</button>
                                        {erorrPrueba}
                                        {seEnvia}
                                    </div>
                                </form>
                            </main>
                        </div>
                    }

                    {tipoDeRespuestaCredito === 1 && <SolicitudFinalizadaMobile numFolio={numFolio}/>}

                    {/*tipoDeRespuestaCredito === 2 && <SolicitudCreditoAprobado idCredito={idCredito}/>*/}

                    {/*tipoDeRespuestaCredito === 3 && <PantallaError objError={objRespuestaError} />*/}

                </>
    )
}